module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gd-Hc-Id-Ja.258ee77a.png";